import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, Typography, Result } from "antd";
import GroupCreationForm from "./GroupCreationForm";
import { createStaticGroup } from "../../actions/api";
import { groupsUserRoleIdentifier } from "../../config";
import { showWarningNotification } from "../../util";
import PropTypes from "prop-types";

const GroupCreate = ({ title, dynamic, icon }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCreate = async (values) => {
    setLoading(true);
    const response = await dispatch(createStaticGroup(values));

    if (response?.payload?.data) {
      if (response.payload.request_id) {
        showWarningNotification(
          response.payload.message,
          "The prefix administrators have been informed"
        );
        navigate(`/requests`);
      } else {
        navigate(`/group/${response.payload.data.id}/details`);
      }
    } else {
      console.error(response);
      navigate(`/`);
    }

    setLoading(false);
  };

  return (
    <Card
      title={
        <Typography.Title level={4} style={{ margin: 0 }}>
          {React.cloneElement(icon, {
            style: {
              marginRight: 8,
              color: "#bfbfbf",
            },
          })}
          {title}
        </Typography.Title>
      }
    >
      {groupsUserRoleIdentifier === "groups_user" ? (
        <GroupCreationForm
          isEdit={false}
          dynamic={dynamic}
          handleSubmit={handleCreate}
          loading={loading}
        />
      ) : (
        <Result
          status="403"
          title="You don't have the access rights to create a group."
        />
      )}
    </Card>
  );
};

GroupCreate.propTypes = {
  title: PropTypes.string.isRequired,
  dynamic: PropTypes.bool.isRequired,
  icon: PropTypes.element.isRequired,
};

export default GroupCreate;
